namespace Solovis.InvDataSelectors {

    export class TransactionSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private selectionCallback;
        private cancelCallback;

        private idInput;

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        }

        
        public doRender() {
            var self = this;

            $("<span>").text("Transaction ID").appendTo(this.container)
                .css("margin-right", "5px");

            this.idInput = $("<input>").attr("type", "text").appendTo(this.container)
                .css("margin-right", "5px");

            var findButton = $("<button>").text("Find").appendTo(this.container);

            findButton.click(function () {
                var transactionId = parseInt(self.idInput.val());

                self._portalServices.rpc().invoke("~/Selectors/TransactionSelector/GetTransactionData", { transactionId: transactionId },
                    function (response, success) {
                        if (success) {
                            var transactionData = response.result;
                            self.selectionCallback(transactionData);
                        }
                    });
            });

            // Trigger cancel when escape is pressed.
            $(this.idInput).keyup(function (e) {
                if (e.keyCode == 27) {
                    // Escape was pressed.
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                }
            });
        };

        public focus() {
            if (this.idInput) {
                this.idInput.focus();
            }
        };
    }

}